module.exports = __webpack_public_path__ + "static/media/navio.c7d2312d.webp";